export type ProgressStepStatus = "pending" | "active" | "completed" | "error";

export type ProgressStep = {
  key: string;
  label: string;
  status: ProgressStepStatus;
};

export type StartProgressLoadingConfig = {
  title: string;
  loadingMessage?: string;
  steps: ProgressStep[];
};

export type LoadingBridgeApi = {
  startLoading: (message?: string) => void;
  stopLoading: () => void;
  setLoadingMessage: (message: string) => void;
  startProgressLoading: (config: StartProgressLoadingConfig) => void;
  updateProgressStep: (stepKey: string, status: ProgressStepStatus) => void;
  setProgressValue: (value: number) => void;
  beginNavigationLoading: () => void;
};

let bridge: LoadingBridgeApi | null = null;

export function registerLoadingBridge(api: LoadingBridgeApi | null) {
  bridge = api;
}

export function getLoadingBridge(): LoadingBridgeApi | null {
  return bridge;
}
